import api from '../../../App/socket';

export const changeUserStatus = (_id, status) => api.send({
    api: 'db',
    model: 'User',
    action: 'Update',
    options: {
        update: {
            ref_user_status: status,
        },
        where: {
            _id,
        },
    },
}).then(response => response.options).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/requests/change_user_status_request.js